import iconSort from '../../../../assets/images/InvestmentPortfolio/icon-sort.svg'

import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { setFilterStockInvest, setStockFilterData } from 'store/actionReducers/StockInvestStore';

export default function SortData() {
    const StockInvestStore = useSelector((state: any) => state?.StockInvestStore)
    const [sortShow, setSortShow] = useState(false);
    const dispatch = useDispatch();
    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef);

    const handleChangeSort = (tab: string) => {
        const paramsNews = { ...StockInvestStore?.FilterStockInvest }
        if (tab === 'thanh-khoan') {
            paramsNews.liquidityFilter = 'desc';
            paramsNews.marCapFilter = '';
        } else if (tab === 'von-hoa') {
            paramsNews.liquidityFilter = '';
            paramsNews.marCapFilter = 'desc';
        }
        dispatch(setStockFilterData([]))
        paramsNews.page = 0
        dispatch(setFilterStockInvest(paramsNews))
        setSortShow(!sortShow)
    }

    const handleOpenSort = () => {
        setSortShow(!sortShow)
    }

    function useOutsideAlerter(ref: any) {
        useEffect(() => {
            /**
             * Alert if clicked on outside of element
             */
            function handleClickOutside(event: any) {
                if (ref.current && !ref.current.contains(event.target)) {
                    // alert("You clicked outside of me!");
                    setSortShow(false)
                }
            }
            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }

    return (
        <>
            <div className={`fubctswanv ${sortShow ? 'qjkjojocsn' : ''}`} ref={wrapperRef}>
                <div className='hwjreugsaf' onClick={() => handleOpenSort()}>
                    <img className='zxecsvvjji' alt="" src={iconSort} />
                </div>
                <div className='ugatoghnjs'>
                    <div onClick={() => handleChangeSort('thanh-khoan')}
                        className={`kuociolngb ${StockInvestStore?.FilterStockInvest?.liquidityFilter === 'desc' ? 'uojfebbbtp' : ''}`}>Thanh khoản</div>
                    <div onClick={() => handleChangeSort('von-hoa')}
                        className={`kuociolngb ${StockInvestStore?.FilterStockInvest?.marCapFilter === 'desc' ? 'uojfebbbtp' : ''}`}>Vốn hoá</div>
                </div>
            </div>
        </>
    )
}